// extracted by mini-css-extract-plugin
export default {"banner":"ArenaBanner_banner__jlGr-","bannersingle":"ArenaBanner_bannersingle__Lky6O"};